module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/estate.811b9399.svg";